//region block: pre-declaration
//endregion
function platformRequestDefaultTransform(contentType, context, body) {
  return null;
}
function platformResponseDefaultTransformers(_this__u8e3s4) {
}
//region block: exports
export {
  platformRequestDefaultTransform as platformRequestDefaultTransformv8a3p2llr8mo,
  platformResponseDefaultTransformers as platformResponseDefaultTransformers258gm9ywvn5cc,
};
//endregion

//# sourceMappingURL=DefaultTransform.nonJvm.mjs.map
